
  const bannerSlider = document.querySelector('.main_banner.splide');
  if (bannerSlider) {
    const splide = new Splide(bannerSlider, {
      type         : 'loop',
      perPage      : 1,
      autoplay     : true,
      interval     : 5000,
      pauseOnHover : false,
      arrows       : false,
      pagination   : true,
      speed        : 1000,
      wheel        : false,
      releaseWheel : false,
    });

    splide.on('mounted', function () {
      const pagination = bannerSlider.querySelector('.splide__pagination');
      if (pagination) {
        pagination.innerHTML = ''; 
        splide.refresh();
      }
    });

    splide.mount();
  }


  const slidersp = document.querySelectorAll('.custom_product_splide');
  slidersp.forEach(function (splideEl) {
    new Splide(splideEl, {
      type: 'loop',
      perPage: 5,
      gap: '3rem',
      pagination: false,
      arrows: true,
      speed: 800,
      perMove: 1, 
      focus  : 0,
      autoplay: true,  
      omitEnd: true,
      interval: 4000,   
      throttle: 300,
      pauseOnHover: true,     
      pauseOnFocus: false,
      breakpoints: {
        1199: {
          perPage: 4,
          gap: '2rem'
        },
        1024: {
          perPage: 3,
          gap: '2rem'
        },
        767: {
          perPage: 2,
          gap: '1rem'
        },
        480: {
          perPage: 1,
          gap: '0.5rem'
        }
      }
    }).mount();
  });

